import React from "react";
import {
    Datagrid,
    ImageField,
    List,
    ListProps,
    NumberField,
    TextField
} from "react-admin";

const RecipeList = (props: ListProps) => (
    <List
        {...props}
        sort={{ field: 'title', order: 'ASC' }}
        perPage={10}
    >
        <Datagrid rowClick="edit">
            <TextField source="id" label="ID" />
            <TextField source="name_en" label="Name (English)" />
            <TextField source="name_ar" label="Name (Arabic)" />
            <ImageField source="featured_image" label="Featured Image" />
            <NumberField source="active" label="Active" />
        </Datagrid>
    </List>
)

export default RecipeList;